function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, key) => {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
    }, obj);
}
const sumObjectKeys = (obj, keys) =>
    keys.reduce((sum, keyPath) => {
        const val = sumAllKeys(getNestedValue(obj, keyPath));
        const num = Number(val);
        if (!isNaN(num)) {
            return sum + num;
        }
        return sum;
    }, 0);

const sumAllKeys = (input) => {
    if (typeof input === 'number') {
        return input;
    }

    if (typeof input === 'string') {
        const num = Number(input);
        return isNaN(num) ? 0 : num;
    }

    if (typeof input === 'object' && input !== null) {
        return Object.values(input).reduce(
            (sum, val) => sum + sumAllKeys(val),
            0
        );
    }

    return 0;
};
export { sumObjectKeys, sumAllKeys };
